import { HiTrendingUp, HiTrendingDown } from 'react-icons/hi'

type Props = {
  totalSales: string
  lastMonthSales: string
  currentMonthSales: string
  trend: number
}

export const SalesCard: React.FC<Props> = ({ totalSales, lastMonthSales, currentMonthSales, trend }) => {
  return (
    <div className='bg-white rounded-xl shadow-md p-6 flex flex-col'>
      <div className='flex items-center mb-4'>
        <div className='p-3 bg-green-100 rounded-lg'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-5 w-5 text-green-600'
            viewBox='0 0 20 20'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              d='M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z'
              clipRule='evenodd'
            />
          </svg>
        </div>
        <h2 className='ml-3 text-lg font-semibold text-gray-700'>Vendas Totais</h2>
      </div>
      <div className='text-3xl font-bold text-gray-800 mb-4'>{totalSales}</div>
      <div className='grid grid-cols-2 gap-3 mb-2'>
        <div className='flex flex-col'>
          <span className='text-sm text-gray-500'>Mês anterior:</span>
          <span className='text-sm font-medium'>{lastMonthSales}</span>
        </div>
        <div className='flex flex-col'>
          <span className='text-sm text-gray-500'>Mês atual:</span>
          <span className='text-sm font-medium'>{currentMonthSales}</span>
        </div>
      </div>
      <div className='flex items-center mt-auto'>
        {trend > 0 ? (
          <>
            <HiTrendingUp className='text-green-500 mr-1' />
            <span className='text-green-500 font-medium'>
              {trend.toFixed(1)}%
            </span>
          </>
        ) : (
          <>
            <HiTrendingDown className='text-red-500 mr-1' />
            <span className='text-red-500 font-medium'>
              {Math.abs(trend).toFixed(1)}%
            </span>
          </>
        )}
        <span className='text-sm text-gray-500 ml-2'>vs mês anterior</span>
      </div>
    </div>
  )
}
